<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p>My writer’s group in Dunedin for their continued support and friendship.</p>
<p>Thank you to my readers at Warepa School for their feedback.</p>
<p>Thanks to Austin Macauley’s team for their support and keeping their faith in me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?70d0e5ae